import { numericFormatter } from "react-number-format";
import { RespuestaSolicitudesPrepagoDto } from "../models/respuestaSolciitudesPrepagoDto";
import { columns } from "../../../dtos/columns";
import AccionesPrepago from "../components/accionesPrepago";

interface IProps {
  controlTabla: any;
  irALiquidarSolicitud: (solicitudId: number) => void;
  isDesactivado?: boolean;
}

export function useColumnSolicitudesPrepago({ controlTabla, irALiquidarSolicitud, isDesactivado}: IProps) {
  const COLUMNS: columns<RespuestaSolicitudesPrepagoDto>[] = [
    {
      name: "Acciones",
      selector: (row: RespuestaSolicitudesPrepagoDto) => row.id,
      cell: (row) => <AccionesPrepago estado={row.estado} 
                                      actionLiquidar={() => {irALiquidarSolicitud(row.id)}} 
                                      actionRecaudar={() => {}}
                                      actionDesrecaudar={() => {}}
                                      actionRemesar={() => {}}
                                      isDesactivado={isDesactivado}
                                    />,
      sortable: true,
      sortField: "id",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha solicitud",
      selector: (row: RespuestaSolicitudesPrepagoDto) => {
        const fecha = new Date(row.fechaSolicitud!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaSolicitud",
      wrap: true,
      export: true,
    },
    {
      name: "Tipo prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => row.tipo,
      sortable: true,
      sortField: "tipo",
      wrap: true,
      export: true,
    },
    {
      name: "Motivo prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => row.motivo,
      sortable: true,
      sortField: "motivo",
      wrap: true,
      export: true,
    },
    {
      name: "Fecha prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => {
        const fecha = new Date(row.fechaPago!);
        if (isNaN(fecha.getTime())) return 'Desconocido';

        const day = String(fecha.getDate()).padStart(2, '0');
        const month = String(fecha.getMonth() + 1).padStart(2, '0');
        const year = fecha.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      sortField: "fechaPago",
      wrap: true,
      export: true,
    },
    {
      name: "Monto prepago",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `$${row.totalPagar}` || '',
      cell: (row) => numericFormatter((row.totalPagar ?? 0).toString(), {
        "thousandsGroupStyle": "thousand",
        "thousandSeparator": ".",
        "decimalSeparator": ",",
        "prefix": " $"
      }),
      sortable: true,
      sortField: "totalPagar",
      wrap: true,
      export: true,
    },
    {
      name: "Estado",
      selector: (row: RespuestaSolicitudesPrepagoDto) => `${row.estado}`,
      sortable: true,
      sortField: "estado",
      wrap: true,
      export: true,
    },
  ];

  return { COLUMNS };
}
